// Monaco workers configuration for Vite
// This ensures language services run in Web Workers instead of the main thread
// to avoid UI freezes and console warnings.
//
// Note: This file must be imported once before any Monaco usage.

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite worker import query
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite worker import query
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite worker import query
import cssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite worker import query
import htmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite worker import query
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker'

// Declare the global MonacoEnvironment for worker resolution
declare global {
  interface Window {
    MonacoEnvironment?: any;
  }
}

// Some bundlers reference self instead of window in workers
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _global: any = (typeof self !== 'undefined' ? self : window) as any

_global.MonacoEnvironment = {
  getWorker(_workerId: string, label: string) {
    if (label === 'json') return new jsonWorker()
    if (label === 'css' || label === 'scss' || label === 'less') return new cssWorker()
    if (label === 'html' || label === 'handlebars' || label === 'razor') return new htmlWorker()
    if (label === 'typescript' || label === 'javascript') return new tsWorker()
    return new editorWorker()
  },
}






